import React from 'react'
import Header from '../components/Header/Header'
import EditAtt from '../components/editAttendance/EditAtt'

function EditAttetence() {
  return (
    <div>
        <Header/>
        <EditAtt/>
    </div>
  )
}

export default EditAttetence